import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { IUsefullContact } from '../../Models';

interface IUsefullContactListState {
    modal: any;
}

interface IUsefullContactListProps {
    usefullContactList: IUsefullContact[];
    eAppointmentUrl: string;
    takeAppointment: string;
    publicTransport: string;
    setBounce: (event: number) => void;
    stopBounce: (event: number) => void;
    homepageUrl: string;
    usefullContactDetailPage: string;
    lang: string;
}

export class UsefullContactList extends Component<
    IUsefullContactListProps,
    IUsefullContactListState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            modal: null,
        };
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
    }

    handleCloseModal() {
        this.setState({ modal: null });
    }

    handleOpenModal(item: IUsefullContact) {
        const stib = item.publicTransportAccess.replace(
            /(\[)(\d+)(\])/g,
            "<a target='_blank' href='//www.stib-mivb.be/horaires-dienstregeling2.html?l=" +
                this.props.lang +
                "&_line=$2&_directioncode=V' style='' class='text-decoration-none line line--$2'>" +
                '$2' +
                '</a>'
        );

        const modal = (
            <ReactModal
                isOpen={true}
                className="modal__dialog"
                overlayClassName="modal__backdrop"
                onRequestClose={() => this.handleCloseModal()}
                shouldCloseOnEsc={true}
                closeTimeoutMS={200}
                ariaHideApp={false}
                bodyOpenClassName="dialog--open"
            >
                <button
                    className="modal__close btn-no-look"
                    onClick={() => this.handleCloseModal()}
                >
                    <i className="icon-cross"></i>
                    <span className="sr-only">Fermer</span>
                </button>
                <div className="modal__content">
                    <div dangerouslySetInnerHTML={{ __html: stib }}></div>
                </div>
            </ReactModal>
        );
        this.setState({ modal });
    }

    render() {
        return (
            <>
                {this.props.usefullContactList &&
                    this.props.usefullContactList.map((item) => {
                        return (
                            <div
                                className="map-tile-container"
                                key={item.id}
                                onMouseEnter={() =>
                                    this.props.setBounce(item.id)
                                }
                                onMouseLeave={() =>
                                    this.props.stopBounce(item.id)
                                }
                            >
                                <article
                                    className="map-tile"
                                    id={item.id.toString()}
                                >
                                    {item.usefullContactDetailInternalLink ? (
                                        <a
                                            href={
                                                item.usefullContactDetailInternalLink
                                            }
                                        >
                                            <div className="d-none d-lg-block img-container">
                                                {item.logoUrl && (
                                                    <img
                                                        src={item.logoUrl}
                                                        alt={item.title}
                                                    />
                                                )}
                                            </div>
                                        </a>
                                    ) : (
                                        <a
                                            href={
                                                this.props
                                                    .usefullContactDetailPage +
                                                item.id +
                                                '-' +
                                                item.urlTitle
                                            }
                                        >
                                            <div className="d-none d-lg-block img-container">
                                                {item.logoUrl && (
                                                    <img
                                                        src={item.logoUrl}
                                                        alt={item.title}
                                                    />
                                                )}
                                            </div>
                                        </a>
                                    )}
                                    <div className="content">
                                        {item.fieldOfSupport && (
                                            <em className="denomination">
                                                {item.fieldOfSupport.join(', ')}
                                            </em>
                                        )}
                                        {item.usefullContactDetailInternalLink ? (
                                            <a
                                                href={
                                                    item.usefullContactDetailInternalLink
                                                }
                                            >
                                                <h3>{item.title}</h3>
                                            </a>
                                        ) : (
                                            <a
                                                href={
                                                    this.props
                                                        .usefullContactDetailPage +
                                                    item.id +
                                                    '-' +
                                                    item.urlTitle
                                                }
                                            >
                                                <h3>{item.title}</h3>
                                            </a>
                                        )}
                                        <ul className="picto">
                                            {(item.streetAndNumber ||
                                                item.postalCode ||
                                                item.city) && (
                                                <li>
                                                    <i className="icon-place"></i>
                                                    <span className="text">
                                                        <a
                                                            href={
                                                                'https://www.google.com/maps/search/?api=1&query=' +
                                                                item.latitude.replace(
                                                                    ',',
                                                                    '.'
                                                                ) +
                                                                ',' +
                                                                item.longitude.replace(
                                                                    ',',
                                                                    '.'
                                                                )
                                                            }
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {
                                                                item.streetAndNumber
                                                            }
                                                            , {item.postalCode}{' '}
                                                            {item.city}
                                                        </a>
                                                    </span>
                                                </li>
                                            )}
                                            {item.phoneNumber && (
                                                <li>
                                                    <i className="icon-phone"></i>
                                                    <span className="text">
                                                        <a
                                                            href={
                                                                'tel:' +
                                                                item.phoneNumber
                                                            }
                                                        >
                                                            {item.phoneNumber}
                                                        </a>
                                                    </span>
                                                </li>
                                            )}
                                            {item.email && (
                                                <li>
                                                    <i className="icon-write"></i>
                                                    <span className="text">
                                                        <a
                                                            href={
                                                                'mailTo:' +
                                                                item.email
                                                            }
                                                        >
                                                            {item.email}
                                                        </a>
                                                    </span>
                                                </li>
                                            )}
                                            {item.website && (
                                                <li>
                                                    <i className="icon-website"></i>
                                                    <span className="text">
                                                        <a
                                                            href={
                                                                '//' +
                                                                item.website
                                                            }
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {item.website}
                                                        </a>
                                                    </span>
                                                </li>
                                            )}
                                        </ul>
                                        {item.activateEappointment && (
                                            <a
                                                href={
                                                    this.props.eAppointmentUrl
                                                }
                                                target="_blank"
                                                className="btn-primary"
                                                rel="noreferrer"
                                            >
                                                {this.props.takeAppointment}
                                            </a>
                                        )}
                                        {item.publicTransportAccess && (
                                            <div className="align-right">
                                                <a
                                                    className="more"
                                                    onClick={() =>
                                                        this.handleOpenModal(
                                                            item
                                                        )
                                                    }
                                                >
                                                    {this.props.publicTransport}
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                </article>
                            </div>
                        );
                    })}
                {this.state.modal}
            </>
        );
    }
}
